import React, { useEffect, useState } from "react";
import Modal from "react-awesome-modal";
import { Link } from "react-router-dom";
import useDelete from "../../Hooks/useDelete";
import swal from "sweetalert";
import useUpdate from "../../Hooks/useUpdate";
import useValidateRole from "../../Hooks/useValidateRole";
import Table from "../../Components/Table";
import Api from "../../Hooks/Api";
import Upload from "../../Hooks/Upload";
import Select from "react-select";
import { Progress } from "reactstrap";
const Indicator = (props) => {
  const [open, setOpen] = useState(false);
  const [inputs, setInputs] = useState({});
  const [inputsActivities, setInputsActivities] = useState({});
  const [inputsTeam, setInputsTeam] = useState({});
  const [documents, setDocuments] = useState({});
  const [view, setView] = useState(false);
  const [viewActivities, setViewActivities] = useState(false);
  const [productOptions, setProductOptions] = useState([]);
  const [mouOptions, setMouOptions] = useState([]);
  const [marketingOptions, setmarketingOptions] = useState([]);
  const [policyOptions, setPolicyOptions] = useState([]);
  const [investmentOptions, setInvestmentOptions] = useState([]);
  const [viewDocuments, setViewDocuments] = useState(false);
  const [viewTeam, setViewTeam] = useState(false);
  const [update, setUpdate] = useState(false);
  const [PageRole, setPageRole] = useState("Add Investments");
  const [alldataCollection, setAllDataCollection] = useState([]);
  const [allActivities, setAllActivities] = useState([]);
  const [allDocuments, setAllDocuments] = useState([]);
  const [allTeams, setAllTeams] = useState([]);
  const [documentTypes, setdocumentTypes] = useState([]);
  const [activeTab, setActiveTab] = useState("Campaign");
  const [RowData, setRowData] = useState([]);

  const [selectedFile, setselectedFile] = useState("");
  const [loaded, setloaded] = useState("");
  const [message, setmessage] = useState("");
  const url = "api/indicators";

  const convertTimestampToDate = (timeStamp) => {
    return new Date(timeStamp).toLocaleDateString("en-US");
  };
  const maxSelectFile = (event) => {
    let files = event.target.files; // create file object
    if (files.length > 1) {
      const msg = "Only One file can be uploaded at a time";
      event.target.value = null;
      setmessage(msg);

      return false;
    }
    return true;
  };
  const onChangeHandler = (event) => {
    //for multiple files
    var files = event.target.files;
    if (maxSelectFile(event)) {
      setselectedFile(files);
      setloaded(0);
    }
  };
  const onClickHandler = (event) => {
    event.preventDefault();
    if (selectedFile) {
      const data = new FormData();
      for (var x = 0; x < selectedFile.length; x++) {
        data.append("file", selectedFile[x]);
      }
      Upload.post("/api/upload/files", data, {
        // receive two parameter endpoint url ,form data
        onUploadProgress: (ProgressEvent) => {
          setloaded((ProgressEvent.loaded / ProgressEvent.total) * 100);
        },
      })
        .then((res) => {
          if (res.status == "200" && res.data.resultCode == "00") {
            setmessage("Uploaded successfully");
            setDocuments((documents) => ({
              ...documents,
              path: res.data.data,
            }));
          } else {
            setmessage("upload fail");
          }
        })
        .catch((err) => {
          setmessage("upload fail");
        });
    } else {
      setmessage("Select a file to upload");
    }
  };

  const handleSelectDocumentsChange = (UserGroup, actionMeta) => {
    setDocuments((documents) => ({
      ...documents,
      [actionMeta.name]: UserGroup.value,
    }));
  };
  const fetchdataCollection = async (investmentId) => {
    try {
      Api.get("api/dataCollection/getByIndicatorId?indicatorId=" + investmentId)
        .then(function (response) {
          if (response.status === 200) {
            setAllDataCollection(response.data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {
      console.error("Error fetching incidentTypes:", error);
    }
  };
  const fetchDocuments = async (indicatorId) => {
    try {
      Api.get("api/documents/getByIndicatorId?indicatorId=" + indicatorId)
        .then(function (response) {
          if (response.status === 200) {
            setAllDocuments(response.data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {
      console.error("Error fetching documents:", error);
    }
  };
  const fetchDataValidation = async (indicatorId) => {
    try {
      Api.get("api/dataValidation/getByIndicatorId?indicatorId=" + indicatorId)
        .then(function (response) {
          if (response.status === 200) {
            setAllTeams(response.data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {
      console.error("Error fetching incidentTypes:", error);
    }
  };

  const fetchDocumentTypes = async () => {
    try {
      Api.get("api/docType/getAll?page=0&size=100")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            data.docType.forEach((k) => {
              let col = {
                value: k.id,
                label: k.name,
              };
              setdocumentTypes((documentTypes) => [...documentTypes, col]);
            });
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {
      console.error("Error fetching incidentTypes:", error);
    }
  };
  const MoreActions = (props) => {
    return (
      <span>
        <a
          class="btn btn-secondary btn-sm dropdown-toggle"
          href="#"
          role="button"
          id="dropdownMenuLink"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          More Actions&nbsp;&nbsp;
          <i class="fa fa-caret-down" aria-hidden="true"></i>
        </a>

        <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
          <a
            style={{ cursor: "pointer" }}
            class="dropdown-item "
            onClick={(e) => handleView(props.selecteditem, e)}
          >
            View
          </a>

          <a
            style={{ cursor: "pointer" }}
            class="dropdown-item "
            onClick={(e) => handleEdit(props.selecteditem, e)}
          >
            Edit
          </a>

          <a
            style={{ cursor: "pointer" }}
            class="dropdown-item "
            onClick={(e) => HandleDelete(props.selecteditem, e)}
          >
            Delete
          </a>
        </div>
      </span>
    );
  };

  const setIncidentsdata = async (data) => {
    const rows = data?.indicators || [];

    rows.forEach((k) => {
      const Rowdata = {
        project: k.product
          ? k.product.name
          : k.investment
          ? k.investment.name
          : k.mou
          ? k.mou.name
          : "",
        id: k.id,
        name: k.name,
        activities: k.activities?.name,
        status: k.status,
        categoryId: k.categoryId,
        timeline: formatDate(k.activities?.plannedEndDate),
        comments: k.comments,
        Actions: <MoreActions selecteditem={k} />,
      };
      setRowData((inputs) => [...inputs, Rowdata]);
    });
  };
  const FetchAll = async () => {
    setRowData([]);
    try {
      Api.get(url + "/getAll?page=0&size=10")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setIncidentsdata(data);
            const totalPages = data.totalPages;
            for (let i = 0; i < totalPages; i++) {
              let nextPage = parseFloat(i) + parseFloat(1);
              Api.get(url + "/getAll?page=" + nextPage + "&size=10")
                .then(function (response) {
                  if (response.status === 200) {
                    const data = response.data;
                    setIncidentsdata(data);
                  }
                })
                .catch(function (error) {})
                .then(function () {
                  // always executed
                });
            }
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {
      console.error("Error fetching securityIncidents:", error);
    }
  };

  const fetchProductStatus = async () => {
    try {
      Api.get("/api/product/getAll?page=0&size=1000")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setProductOptions(data.product);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  const fetchInvestment = async () => {
    try {
      Api.get("/api/investment/getAll?page=0&size=1000")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setInvestmentOptions(data.investment);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  const fetchMou = async () => {
    try {
      Api.get("/api/mou/getAll?page=0&size=1000")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setMouOptions(data.mou);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  const fetchMarketing = async () => {
    try {
      Api.get("/api/marketingAndPromotion/getAll?page=0&size=1000")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setmarketingOptions(data.marketingAndPromotion);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  const fetchPolicy = async () => {
    try {
      Api.get("/api/policy/getAll?page=0&size=1000")
        .then(function (response) {
          if (response.status === 200) {
            const data = response.data;
            setPolicyOptions(data.policy);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };

  useEffect(() => {
    FetchAll();
    fetchPolicy();
    fetchDocumentTypes();
    fetchProductStatus();
    fetchMou();
    fetchInvestment();
    fetchMarketing();
  }, []);

  const handleOpenModal = () => {
    setInputs({});
    setOpen(true);
  };
  const fetchACtivities = async (url) => {
    try {
      Api.get(url)
        .then(function (response) {
          if (response.status === 200) {
            setAllActivities(response.data);
          }
        })
        .catch(function (error) {})
        .then(function () {
          // always executed
        });
    } catch (error) {}
  };
  const handleInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setInputs((inputs) => ({ ...inputs, [name]: value }));
    if (name === "productId") {
      fetchACtivities("api/activities/findByProductId?productId=" + value);
    } else if (name === "mouId") {
      fetchACtivities("api/activities/findByMouId?mouId=" + value);
    } else if (name === "investmentId") {
      fetchACtivities(
        "api/activities/findByInvestmentId?investmentId=" + value
      );
    } else if (name === "marketingId") {
      fetchACtivities("api/activities/findByMarketingId?marketingId=" + value);
    } else if (name === "policyId") {
      fetchACtivities("api/activities/findByPolicyId?policyId=" + value);
    }
  };
  const handleActivitiesInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setInputsActivities((inputsActivities) => ({
      ...inputsActivities,
      [name]: value,
    }));
  };
  const handleTeamInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setInputsTeam((inputsTeam) => ({ ...inputsTeam, [name]: value }));
  };
  const handleDocumentsInputChange = (event) => {
    event.persist();
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    setDocuments((documents) => ({ ...documents, [name]: value }));
  };
  const handleEdit = (k) => {
    setInputs(k);
    setInputsActivities((inputsActivities) => ({
      ...inputsActivities,
      ["indicatorId"]: k.id,
    }));
    setInputsTeam((inputsTeam) => ({ ...inputsTeam, ["indicatorId"]: k.id }));
    setDocuments((documents) => ({ ...documents, ["indicatorId"]: k.id }));
    if (k.id) {
      setOpen(true);
      setUpdate(true);
      setView(false);
      fetchdataCollection(k.id);
      fetchDocuments(k.id);
      fetchDataValidation(k.id);
    } else {
      alert("Select a record to edit");
    }
  };

  const handleView = (k) => {
    setInputs(k);
    setInputsActivities((inputsActivities) => ({
      ...inputsActivities,
      ["indicatorId"]: k.id,
    }));
    setInputsTeam((inputsTeam) => ({ ...inputsTeam, ["indicatorId"]: k.id }));
    setDocuments((documents) => ({ ...documents, ["indicatorId"]: k.id }));
    if (k.id) {
      fetchdataCollection(k.id);
      fetchDocuments(k.id);
      fetchDataValidation(k.id);
      setView(true);
      setViewTeam(true);
      setViewActivities(true);
      setViewDocuments(true);
      setUpdate(false);
      setOpen(true);
    } else {
      alert("Select a record to view");
    }
  };

  const handleCloseModal = () => {
    setInputs({});
    setOpen(false);
    setView(false);
    setUpdate(false);
  };

  const HandleSave = (inputs, url, menu) => {
    useSave(url + "/create", inputs, menu);
    setTimeout(function () {
      FetchAll();
    }, 4000);
  };

  const HandleUpdate = (inputs, url) => {
    useUpdate(url + "/update", inputs);
    setTimeout(function () {
      FetchAll();
    }, 4000);
  };
  const useSave = (url = ``, inputs = {}, menu = ``, config = {}) => {
    let data;
    let headers;

    if (inputs instanceof FormData) {
      data = inputs;
      headers = { ...config.headers }; // Don't set Content-Type header, let the browser set it
    } else {
      data = JSON.stringify(inputs);
      headers = { "Content-Type": "application/json", ...config.headers };
    }
    Api.post(url, data, { headers })
      .then((response) => {
        if (response.data.resultCode === "00") {
          if (menu === "Indicator") {
            var result = JSON.parse(response.data.data);
            setInputs((inputs) => ({ ...inputs, ["id"]: result.id }));
            setInputsActivities((inputsActivities) => ({
              ...inputsActivities,
              ["indicatorId"]: result.id,
            }));
            setInputsTeam((inputsTeam) => ({
              ...inputsTeam,
              ["indicatorId"]: result.id,
            }));
            setDocuments((documents) => ({
              ...documents,
              ["indicatorId"]: result.id,
            }));
          }

          swal("", "saved", "success");
        } else {
          swal("", response.data.description, "error");
        }
      })
      .catch((error) => {
        swal("", "Failed", "error");
      });
  };
  const HandleSubmit = (event) => {
    event.preventDefault();
    if (update) {
      HandleUpdate(inputs, url);
    } else {
      HandleSave(inputs, url, "Indicator");
    }
  };
  const HandleSubmitDocuments = (event) => {
    event.preventDefault();
    if (!documents.indicatorId || documents.indicatorId == "undefined") {
      alert("Add or select indictor first");
      return;
    }
    if (update) {
      HandleUpdate(documents, "api/documents");
    } else {
      HandleSave(documents, "api/documents", "Documents");
    }
    setTimeout(function () {
      fetchDocuments(inputs.id);
    }, 4000);
  };
  const handleSubmitTeam = (event) => {
    event.preventDefault();
    if (!inputsTeam.indicatorId || inputsTeam.indicatorId == "undefined") {
      alert("Add or select indicator first");
      return;
    }
    if (update) {
      HandleUpdate(inputsTeam, "api/teams");
    } else {
      HandleSave(inputsTeam, "api/teams", "Team");
    }
    setTimeout(function () {
      fetchDataValidation(inputs.id);
    }, 4000);
  };

  const HandleSubmitActivities = (event) => {
    event.preventDefault();
    if (
      !inputsActivities.indicatorId ||
      inputsActivities.indicatorId == "undefined"
    ) {
      alert("Add or select indicator first");
      return;
    }
    if (update) {
      HandleUpdate(inputsActivities, "api/dataCollection");
    } else {
      HandleSave(inputsActivities, "api/dataCollection", "Activities");
    }
    setTimeout(function () {
      fetchdataCollection(inputs.id);
    }, 4000);
  };

  const CallDeleteHook = (id) => {
    useDelete(url + "/delete?id=" + id);
    setTimeout(function () {
      FetchAll();
    }, 4000);
  };

  const HandleDelete = (k) => {
    setInputs(k);
    if (k.id) {
      CallDeleteHook(k.id);
    } else {
      alert("Select a record to delete");
    }
  };

  const formatDate = (timestamp) => {
    if (!timestamp) return "";
    const date = new Date(timestamp);
    return date.toISOString().slice(0, 16);
  };

  const ColumnData = [
    { label: "Thematic area", field: "categoryId", sort: "asc" },
    { label: "Project", field: "project", sort: "asc" },
    { label: "Activity", field: "activities", sort: "asc" },
    { label: "Timeline", field: "timeline", sort: "asc" },
    { label: "Comments", field: "comments", sort: "asc" },
    { label: "status", field: "status", sort: "asc" },

    // { label: "UOM", field: "uom", sort: "asc" },

    {
      label: "Actions",
      field: "Actions",
      sort: "asc",
    },
  ];

  const ActionsBtn = () => {
    return (
      <div>
        {/* {useValidateRole(PageRole, "Edit") ? (
                    <button
                        className="btn btn-primary p-2"
                        type="button"
                        onClick={handleEdit}
                    >
                        Update
                    </button>
                ) : null}
                &nbsp; &nbsp;
                {useValidateRole(PageRole, "Remove") ? (
                    <button onClick={HandleDelete} className="btn btn-danger p-2">
                        Delete
                    </button>
                ) : null} */}
        &nbsp;
        <button
          className="btn btn-warning p-2"
          type="button"
          onClick={handleCloseModal}
        >
          Close
        </button>
      </div>
    );
  };

  return (
    <div id="content" className="content">
      <ol className="breadcrumb float-xl-right">
        <li className="breadcrumb-item">
          <Link to="/">Home</Link>
        </li>
        <li className="breadcrumb-item active">Indicators</li>
      </ol>
      <h1 className="page-header mb-3">Indicators</h1>
      <div style={{ backgroundColor: "white" }}>
        <div className="row">
          <div className="col-sm-12 d-flex flex-row float-right">
            &nbsp; &nbsp; &nbsp;
            {useValidateRole(PageRole, "AddNew") ? (
              <button
                onClick={handleOpenModal}
                className="btn btn-primary p-2"
                style={{ marginRight: 5, marginTop: 5 }}
              >
                &nbsp; New Indicator &nbsp;
              </button>
            ) : null}
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12">
            <Table Rows={RowData} columns={ColumnData} />
          </div>
        </div>
      </div>

      <Modal visible={open} width="80%" height="90%" effect="fadeInUp">
        <div style={{ overflowY: "auto", height: "100%" }}>
          <a className="close" onClick={() => handleCloseModal()}>
            &times;
          </a>

          <div className="row">
            <div className="col-sm-5"></div>
            {view ? null : (
              <div className="col-sm-4 font-weight-bold text-blue">
                Indicator
              </div>
            )}
          </div>
          <div className="container-fluid">
            <div className="col-sm-12">
              <div className="ibox-content">
                <br />
                <div className="tab-content" id="myTabContent">
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item" style={{ cursor: "pointer" }}>
                      <a
                        className={`nav-link ${
                          activeTab === "Campaign" ? "active" : ""
                        }`}
                        id="Campaign-tab"
                        onClick={() => setActiveTab("Campaign")}
                        role="tab"
                        aria-selected={activeTab === "Campaign"}
                      >
                        Indicator
                      </a>
                    </li>
                    <li className="nav-item" style={{ cursor: "pointer" }}>
                      <a
                        className={`nav-link ${
                          activeTab === "Activities" ? "active" : ""
                        }`}
                        id="Activities-tab"
                        onClick={() => setActiveTab("Activities")}
                        role="tab"
                        aria-selected={activeTab === "Activities"}
                      >
                        Data Collection
                      </a>
                    </li>
                    <li className="nav-item" style={{ cursor: "pointer" }}>
                      <a
                        className={`nav-link ${
                          activeTab === "Team" ? "active" : ""
                        }`}
                        id="Team-tab"
                        onClick={() => setActiveTab("Team")}
                        role="tab"
                        aria-selected={activeTab === "Team"}
                      >
                        Data Validation
                      </a>
                    </li>
                    <li className="nav-item" style={{ cursor: "pointer" }}>
                      <a
                        className={`nav-link ${
                          activeTab === "Documents" ? "active" : ""
                        }`}
                        id="Documents-tab"
                        onClick={() => setActiveTab("Documents")}
                        role="tab"
                        aria-selected={activeTab === "Documents"}
                      >
                        Documents
                      </a>
                    </li>
                  </ul>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "Campaign" ? "show active" : ""
                    }`}
                    id="Campaign-tab-pane"
                    role="tabpanel"
                    aria-labelledby="Campaign-tab"
                  >
                    <h3>Indicator details</h3>
                    {view ? (
                      <div>
                        <table className="table table-sm">
                          <tbody>
                            <tr>
                              <td className="font-weight-bold">
                                Thematic area:
                              </td>
                              <td>{inputs.categoryId}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">
                                Indicator name:
                              </td>
                              <td>{inputs.name}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">
                                Indicator type:
                              </td>
                              <td>{inputs.type}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">
                                Indicator uom:
                              </td>
                              <td>{inputs.uom}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">Description:</td>
                              <td>{inputs.description}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">Created At:</td>
                              <td>
                                {inputs.createdAt
                                  ? formatDate(inputs.createdAt)
                                  : ""}
                              </td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">Description:</td>
                              <td>{inputs.description}</td>
                            </tr>
                            <tr>
                              <td className="font-weight-bold">Comments:</td>
                              <td>{inputs.comments}</td>
                            </tr>

                            <tr>
                              <td className="font-weight-bold">Created By:</td>
                              <td>{inputs.createdBy}</td>
                            </tr>
                          </tbody>
                        </table>
                        <br />
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <ActionsBtn />
                        </div>
                        <br />
                      </div>
                    ) : (
                      <form className="form-horizontal" onSubmit={HandleSubmit}>
                        <div className="row">
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="statusId"
                                className="font-weight-bold"
                              >
                                Select thematic area:
                              </label>
                              <select
                                className="form-control"
                                name="categoryId"
                                required
                                value={inputs.categoryId || ""}
                                onChange={handleInputChange}
                              >
                                <option value="">Select Category</option>

                                <option key="1" value="product">
                                  Product
                                </option>
                                <option key="2" value="mou">
                                  MOU
                                </option>
                                <option key="3" value="investment">
                                  Investment and Finance
                                </option>
                                <option key="4" value="marketing">
                                  Marketing
                                </option>
                                <option key="4" value="policy">
                                  Policy Research and Inovation
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                        {inputs.categoryId === "product" ? (
                          <div className="row">
                            <div className="col-sm">
                              <div className="form-group">
                                <label
                                  htmlFor="productId"
                                  className="font-weight-bold"
                                >
                                  Select Product:
                                </label>
                                <select
                                  className="form-control"
                                  name="productId"
                                  required
                                  value={inputs.productId || ""}
                                  onChange={handleInputChange}
                                >
                                  <option value="">Select Product</option>
                                  {productOptions &&
                                    productOptions.map((status) => (
                                      <option key={status.id} value={status.id}>
                                        {status.name}
                                      </option>
                                    ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        {inputs.categoryId === "mou" ? (
                          <div className="row">
                            <div className="col-sm">
                              <div className="form-group">
                                <label
                                  htmlFor="mouId"
                                  className="font-weight-bold"
                                >
                                  Select MOU:
                                </label>
                                <select
                                  className="form-control"
                                  name="mouId"
                                  required
                                  value={inputs.mouId || ""}
                                  onChange={handleInputChange}
                                >
                                  <option value="">Select MOU</option>
                                  {mouOptions &&
                                    mouOptions.map((status) => (
                                      <option key={status.id} value={status.id}>
                                        {status.name}
                                      </option>
                                    ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        {inputs.categoryId === "investment" ? (
                          <div className="row">
                            <div className="col-sm">
                              <div className="form-group">
                                <label
                                  htmlFor="investmentId"
                                  className="font-weight-bold"
                                >
                                  Select Investment:
                                </label>
                                <select
                                  className="form-control"
                                  name="investmentId"
                                  required
                                  value={inputs.investmentId || ""}
                                  onChange={handleInputChange}
                                >
                                  <option value="">Select Investment</option>
                                  {investmentOptions &&
                                    investmentOptions.map((status) => (
                                      <option key={status.id} value={status.id}>
                                        {status.title}
                                      </option>
                                    ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        {inputs.categoryId === "marketing" ? (
                          <div className="row">
                            <div className="col-sm">
                              <div className="form-group">
                                <label
                                  htmlFor="marketingId"
                                  className="font-weight-bold"
                                >
                                  Select Marketing:
                                </label>
                                <select
                                  className="form-control"
                                  name="marketingId"
                                  required
                                  value={inputs.marketingId || ""}
                                  onChange={handleInputChange}
                                >
                                  <option value="">Select Marketing</option>
                                  {marketingOptions &&
                                    marketingOptions.map((status) => (
                                      <option key={status.id} value={status.id}>
                                        {status.title}
                                      </option>
                                    ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        {inputs.categoryId === "policy" ? (
                          <div className="row">
                            <div className="col-sm">
                              <div className="form-group">
                                <label
                                  htmlFor="marketingId"
                                  className="font-weight-bold"
                                >
                                  Select Policy and Research:
                                </label>
                                <select
                                  className="form-control"
                                  name="policyId"
                                  required
                                  value={inputs.policyId || ""}
                                  onChange={handleInputChange}
                                >
                                  <option value="">Select Policy</option>
                                  {marketingOptions &&
                                    marketingOptions.map((status) => (
                                      <option key={status.id} value={status.id}>
                                        {status.title}
                                      </option>
                                    ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        ) : null}

                        <div className="row">
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="productId"
                                className="font-weight-bold"
                              >
                                Select Activity:
                              </label>
                              <select
                                className="form-control"
                                name="activityId"
                                required
                                value={inputs.activityId || ""}
                                onChange={handleInputChange}
                              >
                                <option value="">Select Activity</option>
                                {allActivities &&
                                  allActivities.map((status) => (
                                    <option key={status.id} value={status.id}>
                                      {status.name}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="code"
                                className="font-weight-bold"
                              >
                                Indicator Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="name"
                                required
                                value={inputs.name || ""}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="code"
                                className="font-weight-bold"
                              >
                                Status
                              </label>
                              <input
                                type="tex"
                                className="form-control"
                                name="status"
                                required
                                value={inputs.status || ""}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="code"
                                className="font-weight-bold"
                              >
                                Indicator target
                              </label>
                              <input
                                type="number"
                                className="form-control"
                                name="target"
                                required
                                value={inputs.target || ""}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm">
                            <div className="form-group">
                              <label htmlFor="uom" className="font-weight-bold">
                                Select UOM:
                              </label>
                              <select
                                className="form-control"
                                name="uom"
                                required
                                value={inputs.uom || ""}
                                onChange={handleInputChange}
                              >
                                <option value="">Select UOM</option>

                                <option key="Percentage" value="Percentage">
                                  Percentage
                                </option>
                                <option key="Number" value="Number">
                                  Number
                                </option>
                              </select>
                            </div>
                          </div>
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="type"
                                className="font-weight-bold"
                              >
                                Select Type:
                              </label>
                              <select
                                className="form-control"
                                name="type"
                                required
                                value={inputs.type || ""}
                                onChange={handleInputChange}
                              >
                                <option value="">Select Type</option>

                                <option key="Outcome" value="Outcome">
                                  Outcome
                                </option>
                                <option key="OutPut" value="OutPut">
                                  OutPut
                                </option>
                                <option key="Impact" value="Impact">
                                  Impact
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="description"
                                className="font-weight-bold"
                              >
                                Description
                              </label>
                              <textarea
                                type="text"
                                className="form-control"
                                name="description"
                                required
                                value={inputs.description || ""}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="comments"
                                className="font-weight-bold"
                              >
                                Comments
                              </label>
                              <textarea
                                type="text"
                                className="form-control"
                                name="comments"
                                required
                                value={inputs.comments || ""}
                                onChange={handleInputChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <div className="d-flex flex-row">
                            {update ? (
                              <button
                                className="btn btn-primary p-2"
                                type="submit"
                              >
                                Update
                              </button>
                            ) : (
                              <button
                                className="btn btn-primary p-2"
                                type="submit"
                              >
                                Submit
                              </button>
                            )}
                            &nbsp;
                            <button
                              className="btn btn-warning p-2"
                              type="button"
                              onClick={handleCloseModal}
                            >
                              Close
                            </button>
                          </div>
                          <br />
                        </div>
                      </form>
                    )}
                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "Activities" ? "show active" : ""
                    }`}
                    id="Activities-tab-pane"
                    role="tabpanel"
                    aria-labelledby="Activities-tab"
                  >
                    <h3>Data Collection</h3>
                    {viewActivities ? (
                      <div>
                        <button
                          className="btn-primary"
                          onClick={() => {
                            setViewActivities(false);
                          }}
                        >
                          Add data
                        </button>
                        <br />
                        <table className="table table-sm">
                          <tr>
                            <th>id</th>
                            <th>Title</th>
                            <th>ActualValue</th>
                            <th>Collection Date</th>
                            <th>Comments:</th>
                            <th>collectedBy</th>
                            <th>Location</th>
                          </tr>
                          <tbody>
                            {alldataCollection.map((d) => (
                              <tr key={d.id}>
                                <td>{d.id}</td>
                                <td>{d.title}</td>
                                <td>{d.actualValue}</td>
                                <td>
                                  {d.plannedStartDate
                                    ? convertTimestampToDate(d.collectionDate)
                                    : "N/A"}
                                </td>

                                <td>{d.comments}</td>

                                <td>{d.collectedBy}</td>
                                <td>{d.location}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <br />
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <ActionsBtn />
                        </div>
                        <br />
                      </div>
                    ) : (
                      <form
                        className="form-horizontal"
                        onSubmit={HandleSubmitActivities}
                      >
                        <button
                          className="btn-warning"
                          onClick={() => {
                            setViewActivities(true);
                          }}
                        >
                          Back
                        </button>
                        <div className="row">
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="title"
                                className="font-weight-bold"
                              >
                                Title
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="title"
                                required
                                value={inputsActivities.title || ""}
                                onChange={handleActivitiesInputChange}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="code"
                                className="font-weight-bold"
                              >
                                Actual Value
                              </label>
                              <input
                                type="number"
                                className="form-control"
                                name="actualValue"
                                required
                                value={inputsActivities.actualValue || ""}
                                onChange={handleActivitiesInputChange}
                              />
                            </div>
                          </div>
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="code"
                                className="font-weight-bold"
                              >
                                Collected By
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="collectedBy"
                                required
                                value={inputsActivities.collectedBy || ""}
                                onChange={handleActivitiesInputChange}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="collectionDate"
                                className="font-weight-bold"
                              >
                                Collection Date
                              </label>
                              <input
                                type="date"
                                className="form-control"
                                name="collectionDate"
                                required
                                value={inputsActivities.collectionDate || ""}
                                onChange={handleActivitiesInputChange}
                              />
                            </div>
                          </div>
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="location"
                                className="font-weight-bold"
                              >
                                location
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="location"
                                required
                                value={inputsActivities.location || ""}
                                onChange={handleActivitiesInputChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="comments"
                                className="font-weight-bold"
                              >
                                Comments
                              </label>
                              <textarea
                                type="text"
                                className="form-control"
                                name="comments"
                                required
                                value={inputsActivities.comments || ""}
                                onChange={handleActivitiesInputChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <div className="d-flex flex-row">
                            {update ? (
                              <button
                                className="btn btn-primary p-2"
                                type="submit"
                              >
                                Update
                              </button>
                            ) : (
                              <button
                                className="btn btn-primary p-2"
                                type="submit"
                              >
                                Submit
                              </button>
                            )}
                            &nbsp;
                            <button
                              className="btn btn-warning p-2"
                              type="button"
                              onClick={handleCloseModal}
                            >
                              Close
                            </button>
                          </div>
                          <br />
                        </div>
                      </form>
                    )}
                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "Team" ? "show active" : ""
                    }`}
                    id="Team-tab-pane"
                    role="tabpanel"
                    aria-labelledby="Team-tab"
                  >
                    <h3>Data Validation</h3>
                    {viewTeam ? (
                      <div>
                        <button
                          className="btn-primary"
                          onClick={() => {
                            setViewTeam(false);
                          }}
                        >
                          Add Validation
                        </button>
                        <br />
                        <table className="table table-sm">
                          <tr>
                            <th>id</th>
                            <th>Data </th>
                            <th>Validation Date </th>
                            <th>Status </th>
                            <th>Validated By </th>
                            <th>comments </th>
                          </tr>
                          <tbody>
                            {allTeams.map((d) => (
                              <tr key={d.id}>
                                <td>{d.id}</td>
                                <td>{d.data.title}</td>
                                <td>{d.validationDate}</td>
                                <td>{d.status}</td>
                                <td>{d.validatedBy}</td>
                                <td>{d.comments}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <br />
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <ActionsBtn />
                        </div>
                        <br />
                      </div>
                    ) : (
                      <form
                        className="form-horizontal"
                        onSubmit={handleSubmitTeam}
                      >
                        <button
                          className="btn-warning"
                          onClick={() => {
                            setViewTeam(true);
                          }}
                        >
                          Back
                        </button>
                        <div className="row">
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="dataId"
                                className="font-weight-bold"
                              >
                                Select Data:
                              </label>
                              <select
                                className="form-control"
                                name="dataId"
                                required
                                value={inputs.dataId || ""}
                                onChange={handleInputChange}
                              >
                                <option value="">Select Data</option>
                                {alldataCollection &&
                                  alldataCollection.map((status) => (
                                    <option key={status.id} value={status.id}>
                                      {status.title}
                                    </option>
                                  ))}
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="validationDate"
                                className="font-weight-bold"
                              >
                                validationDate
                              </label>
                              <input
                                type="date"
                                className="form-control"
                                name="validationDate"
                                required
                                value={inputsTeam.validationDate || ""}
                                onChange={handleTeamInputChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="status"
                                className="font-weight-bold"
                              >
                                Status
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="status"
                                required
                                value={inputsTeam.status || ""}
                                onChange={handleTeamInputChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="validatedBy"
                                className="font-weight-bold"
                              >
                                Validated By
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="validatedBy"
                                required
                                value={inputsTeam.validatedBy || ""}
                                onChange={handleTeamInputChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="validatedBy"
                                className="font-weight-bold"
                              >
                                comments
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="comments"
                                required
                                value={inputsTeam.comments || ""}
                                onChange={handleTeamInputChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <div className="d-flex flex-row">
                            {update ? (
                              <button
                                className="btn btn-primary p-2"
                                type="submit"
                              >
                                Update
                              </button>
                            ) : (
                              <button
                                className="btn btn-primary p-2"
                                type="submit"
                              >
                                Submit
                              </button>
                            )}
                            &nbsp;
                            <button
                              className="btn btn-warning p-2"
                              type="button"
                              onClick={handleCloseModal}
                            >
                              Close
                            </button>
                          </div>
                          <br />
                        </div>
                      </form>
                    )}
                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "Documents" ? "show active" : ""
                    }`}
                    id="Documents-tab-pane"
                    role="tabpanel"
                    aria-labelledby="Documents-tab"
                  >
                    <h3>Documents</h3>
                    {viewDocuments ? (
                      <div>
                        <button
                          className="btn-primary"
                          onClick={() => {
                            setViewDocuments(false);
                          }}
                        >
                          Add Document
                        </button>
                        <br />
                        <table className="table table-sm">
                          <tr>
                            <th>id</th>
                            <th>Type</th>
                            <th>Name</th>
                            <th>Description </th>
                            <th>View </th>
                          </tr>
                          <tbody>
                            {allDocuments.map((d) => (
                              <tr key={d.id}>
                                <td>{d.id}</td>
                                <td>{d.docType.name}</td>
                                <td>{d.name}</td>
                                <td>{d.description}</td>
                                <td>
                                  <a
                                    href={
                                      process.env.REACT_APP_BASE_URL +
                                      "api/upload/files/" +
                                      d.path
                                    }
                                    target="_blank"
                                  >
                                    {" "}
                                    View{" "}
                                  </a>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <br />
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <ActionsBtn />
                        </div>
                        <br />
                      </div>
                    ) : (
                      <form
                        className="form-horizontal"
                        onSubmit={HandleSubmitDocuments}
                      >
                        <button
                          className="btn-warning"
                          onClick={() => {
                            setViewDocuments(true);
                          }}
                        >
                          Back
                        </button>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label
                                htmlFor="name"
                                className="font-weight-bold"
                              >
                                Document Name
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="name"
                                required
                                value={documents.name || ""}
                                onChange={handleDocumentsInputChange}
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label
                                htmlFor="name"
                                className="font-weight-bold"
                              >
                                Document Type
                              </label>
                              <Select
                                name="typeId"
                                value={documentTypes.filter(
                                  (option) => option.value === documents.typeId
                                )}
                                onChange={handleSelectDocumentsChange}
                                options={documentTypes}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-sm">
                            <div className="form-group">
                              <label
                                htmlFor="description"
                                className="font-weight-bold"
                              >
                                Description
                              </label>
                              <textarea
                                type="text"
                                className="form-control"
                                name="description"
                                required
                                value={documents.description || ""}
                                onChange={handleDocumentsInputChange}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12">
                            <input
                              type="file"
                              className="form-control"
                              name="file"
                              onChange={onChangeHandler}
                              accept=".xlsx, .xls, .csv"
                            />
                          </div>
                          <br />
                          <div className="col-sm-12">
                            <Progress max="100" color="success" value={loaded}>
                              {Math.round(loaded, 2)}%
                            </Progress>
                            <button
                              type="button"
                              class="btn btn-success "
                              onClick={onClickHandler}
                            >
                              Upload
                            </button>
                          </div>
                          <p>{message}</p>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          <div className="d-flex flex-row">
                            {update ? (
                              <button
                                className="btn btn-primary p-2"
                                type="submit"
                              >
                                Update
                              </button>
                            ) : (
                              <button
                                className="btn btn-primary p-2"
                                type="submit"
                              >
                                Submit
                              </button>
                            )}
                            &nbsp;
                            <button
                              className="btn btn-warning p-2"
                              type="button"
                              onClick={handleCloseModal}
                            >
                              Close
                            </button>
                          </div>
                          <br />
                        </div>
                      </form>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Indicator;
